/**
 * @generated SignedSource<<e60f43e4121a2951ba44d57fb11dec7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountid"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountid"
      }
    ],
    "concreteType": "BindCardUnattachedsConnection",
    "kind": "LinkedField",
    "name": "getbindcardsunattached",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BindCardUnattached",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bcId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provisioningAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "usingAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BindCardUnattachedFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BindCardUnattachedFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d75b625850973c286e8621999ccd9d8a",
    "id": null,
    "metadata": {},
    "name": "BindCardUnattachedFetchQuery",
    "operationKind": "query",
    "text": "query BindCardUnattachedFetchQuery(\n  $accountid: UUID!\n) {\n  getbindcardsunattached(accountid: $accountid) {\n    nodes {\n      bcId\n      customerAppId\n      provisioningAccountId\n      usingAccountId\n      appName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "f18a2b7f1b5576311b7e3da0513bd47f";

module.exports = node;
